




























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Proposal } from '@/interfaces/Proposal';
import UploadPhoto from '../UploadPhoto.vue';

@Component({
  components: { UploadPhoto },
})
export default class DialogForm extends Vue {
  $refs!: {
    proposalForm: HTMLFormElement,
  };

  protected isDialogOpen = false;

  protected isFormValid = false;

  protected formTitle = '';

  protected formDescription = '';

  protected picture = '';

  protected formTitleRules = [
    (v: string): boolean | string => !!v || 'Title is required',
    (v: string): boolean | string => (v && v.length > 5) || 'Title must be more than 5 characters',
  ];

  submitProposal(): void {
    if (this.$refs.proposalForm.validate()) {
      this.isDialogOpen = false;
      this.$emit('add-proposal', {
        title: this.formTitle,
        description: this.formDescription,
        image: this.picture,
      } as Proposal);
      this.formTitle = '';
      this.formDescription = '';
      this.picture = '';
    }
  }
}
